module.exports = __webpack_public_path__ + "static/media/bump.038faf1a.svg";